// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__vKx+j","content":"checkbox_content__Iyp2X"};